import React from 'react'

import { Box } from '../../Shared/Base'
import DialogModal, { DialogButton } from '../../Shared/DialogModal'

const AlertResultReport = ({ modal_open, onReport, onClose, ad_id, ad_search_type }) => {
  const [loading, set_loading] = React.useState(false)

  return (
    <DialogModal
      onClose={onClose}
      open={modal_open}
      title="Confirmation"
      actions={
        <>
          <DialogButton isSimple onClick={onClose}>
            Annuler
          </DialogButton>
          <DialogButton
            disabled={loading}
            onClick={async () => {
              set_loading(true)
              await onReport({ reason: 'ad_delete', ad_id })
              set_loading(false)
            }}
          >
            Confirmer
          </DialogButton>
        </>
      }
    >
      <Box>Supprimer cette annonce ?</Box>
    </DialogModal>
  )
}

export default React.memo(AlertResultReport)
